const RAW_PHRASE_TRANSLATIONS: Record<string, string> = {
  'Expertises': 'Expertise',
  'Realisations': 'Projects',
  "L'Agence": 'Agency',
  'Inscription': 'Sign up',
  'Connexion': 'Sign in',
  'Demarrer un projet': 'Start a project',
  'Ouvrir le menu': 'Open menu',
  'Fermer le menu': 'Close menu',
  "L'agence digitale nouvelle generation. Headless, performante, sur-mesure.": 'The new-generation digital agency. Headless, high-performance, tailor-made.',
  'Portails': 'Portals',
  'Espace Client B2B': 'B2B Client Area',
  'Espace Partenaire': 'Partner Area',
  'Carrieres': 'Careers',
  'Pret a transformer votre ecosysteme ?': 'Ready to transform your ecosystem?',
  'Mentions legales': 'Legal notice',
  'Nous contacter': 'Contact us',
  "L'ecosysteme digital": 'The digital ecosystem',
  'sans compromis.': 'without compromise.',
  'Ahime remplace votre stack fragmentee par une architecture Headless centralisee. Performante, securisee, sur-mesure.': 'Ahime replaces your fragmented stack with a centralized headless architecture. High-performance, secure, and tailor-made.',
  'Explorer nos expertises': 'Explore our expertise',
  'Projets delivres': 'Delivered projects',
  'Performance SEO': 'SEO performance',
  'Uptime Garanti': 'Guaranteed uptime',
  'Satisfaction Client': 'Client satisfaction',
  'Nos Expertises': 'Our Expertise',
  'Une approche modulaire pour repondre aux defis complexes de votre industrie.': 'A modular approach to solve your industry’s complex challenges.',
  'Tech & Ingenierie': 'Tech & Engineering',
  "Developpement sur-mesure, Architecture Headless, et integration d'APIs complexes.": 'Custom development, headless architecture, and complex API integrations.',
  'Solutions BTP': 'Construction Solutions',
  'Digitalisation des chantiers et ERP metiers.': 'Construction site digitization and trade-focused ERP solutions.',
  'Transformation digitale et strategie IT.': 'Digital transformation and IT strategy.',
  'Pilotage & Analytics': 'Operations & Analytics',
  'Tableaux de bord, reporting et automatisation pour suivre vos operations en temps reel.': 'Dashboards, reporting, and automation to track your operations in real time.',
  "Decouvrez comment nous fusionnons ingenierie de pointe et design d'exception pour creer des plateformes qui redefinissent les standards de votre industrie.": 'Discover how we blend cutting-edge engineering and standout design to build platforms that redefine your industry standards.',
  'Securite de Niveau Entreprise': 'Enterprise-grade security',
  'Integration IA & Automatisation': 'AI integration & automation',
  'En savoir plus sur notre methodologie': 'Learn more about our methodology',
  'Realisations Phares': 'Featured Projects',
  'Des resultats concrets pour des entreprises ambitieuses.': 'Concrete results for ambitious companies.',
  'Voir tout le portfolio': 'View full portfolio',
  'Ils nous font confiance': 'They trust us',
  'Pret a accelerer ?': 'Ready to accelerate?',
  "Laissez-nous vos coordonnees, nos experts vous recontactent sous 24h pour un audit gratuit de votre ecosysteme.": 'Leave your details and our experts will contact you within 24 hours for a free ecosystem audit.',
  'Envoi...': 'Sending...',
  'Demander un audit': 'Request an audit',
  'Demande envoyee. Nous revenons vers vous sous 24h.': 'Request sent. We will get back to you within 24 hours.',
  "Impossible d'envoyer la demande pour le moment.": 'Unable to send your request at the moment.',
  'Applications Web & Mobiles': 'Web & Mobile Applications',
  'Architectures Microservices': 'Microservices Architectures',
  'Migration Headless': 'Headless Migration',
  'Audit Cybersecurite': 'Cybersecurity Audit',
  'En savoir plus': 'Learn more',
  'Consulting & Strategie': 'Consulting & Strategy',
  "Nous vous accompagnons dans votre transformation digitale. De l'audit initial a la mise en oeuvre de solutions innovantes.": 'We support your digital transformation from initial audit to implementation of innovative solutions.',
  'Audit de Stack Technique': 'Technical stack audit',
  'Strategie de Transformation': 'Transformation strategy',
  'Accompagnement au Changement': 'Change management',
  'Optimisation de Processus': 'Process optimization',
  'Service non trouve.': 'Service not found.',
  'Retour aux expertises': 'Back to expertise',
  'Ce que nous proposons': 'What we provide',
  'Nos Realisations': 'Our Projects',
  'Decouvrez comment nous avons transforme les defis de nos clients en succes mesurables a travers le monde.': 'See how we turned our clients’ challenges into measurable success around the world.',
  'Projets Clients': 'Client Projects',
  'Ecosysteme Ahime': 'Ahime Ecosystem',
  'Lien de demonstration indisponible pour ce projet.': 'Demo link unavailable for this project.',
  'Retour au portfolio': 'Back to portfolio',
  'Refonte E-commerce Headless': 'Headless E-commerce Redesign',
  'Le Defi': 'The Challenge',
  'La Solution Ahime': 'The Ahime Solution',
  'Resultats': 'Results',
  'Temps de chargement': 'Loading time',
  'Taux de conversion': 'Conversion rate',
  'LCP Moyen': 'Average LCP',
  'Visiter le site': 'Visit website',
  "Analyses, tendances et conseils d'experts pour accelerer votre transformation digitale.": 'Insights, trends and expert advice to accelerate your digital transformation.',
  'Rechercher un article...': 'Search for an article...',
  'Aucun article trouve.': 'No article found.',
  'min de lecture': 'min read',
  'Article Ahime': 'Ahime article',
  'Lien copie dans le presse-papiers.': 'Link copied to clipboard.',
  'Impossible de partager pour le moment.': 'Unable to share right now.',
  'Article introuvable': 'Article not found',
  'Cet article est introuvable ou indisponible.': 'This article is unavailable or cannot be found.',
  'Retour aux insights': 'Back to insights',
  "Cet article n'existe pas ou n'est pas encore publie.": 'This article does not exist or is not published yet.',
  'Aucun contenu disponible pour cet article.': 'No content available for this article.',
  'Publie le': 'Published on',
  'Partager': 'Share',
  'Parlons de votre Projet': 'Let’s talk about your project',
  'Pret a transformer votre ecosysteme digital ? Nos experts sont a votre ecoute.': 'Ready to transform your digital ecosystem? Our experts are here to help.',
  'Telephone': 'Phone',
  'Lun - Ven, 9h - 18h': 'Mon - Fri, 9am - 6pm',
  'Bureaux': 'Offices',
  'Deuxieme von apres la pharmacie La Reference': 'Second lane after La Reference pharmacy',
  'Nom complet': 'Full name',
  'E-mail professionnel': 'Business email',
  'Votre besoin': 'Your need',
  'Autre': 'Other',
  'Message': 'Message',
  'Decrivez votre projet...': 'Describe your project...',
  'Votre message a bien ete envoye.': 'Your message has been sent successfully.',
  "Une erreur est survenue pendant l'envoi.": 'An error occurred while sending.',
  'Envoyer': 'Send',
  "L'agence qui reinvente les codes.": 'The agency redefining the rules.',
  "Ahime est nee d'une vision simple : centraliser la complexite pour liberer le plein potentiel de nos clients a travers des solutions technologiques d'exception.": 'Ahime was born from a simple vision: centralize complexity to unlock our clients’ full potential through exceptional technology solutions.',
  'Notre histoire': 'Our story',
  "D'innovation": 'of innovation',
  "Une genese tournee vers l'excellence technique.": 'A foundation built on technical excellence.',
  'Notre Vision': 'Our Vision',
  'Nos Valeurs': 'Our Values',
  'Notre Mission': 'Our Mission',
  'La Methode Ahime': 'The Ahime Method',
  'Notre Parcours': 'Our Journey',
  "L'Equipe": 'The Team',
  'Pret a ecrire la suite avec nous ?': 'Ready to write the next chapter with us?',
  'Editeur du site': 'Website publisher',
  'Adresse': 'Address',
  'Hebergement': 'Hosting',
  "Le site et les donnees sont heberges sur les serveurs d'Ahime Studio.": 'The website and data are hosted on Ahime Studio servers.',
  'Propriete intellectuelle': 'Intellectual property',
  "Le contenu du site est protege par le droit d'auteur. Toute reproduction sans autorisation est interdite.": 'Website content is protected by copyright law. Any unauthorized reproduction is prohibited.',
  'Page introuvable': 'Page not found',
  "Le lien demande n'existe pas ou a ete deplace.": 'The requested link does not exist or has been moved.',
  "Retour a l'accueil": 'Back to home',
  "L'excellence digitale en toute securite.": 'Digital excellence with full security.',
  'Accedez a votre ecosysteme Ahime OS.': 'Access your Ahime OS ecosystem.',
  'Retour au site': 'Back to website',
  'Bienvenue sur Ahime OS. Veuillez vous identifier.': 'Welcome to Ahime OS. Please sign in.',
  'Adresse E-mail': 'Email address',
  'Mot de passe': 'Password',
  'Connexion en cours...': 'Signing in...',
  "Se connecter a l'espace": 'Sign in to workspace',
  'Nouveau client ?': 'New client?',
  'Creer un compte': 'Create an account',
  'Connexion impossible': 'Unable to sign in',
  'Inscription Client': 'Client registration',
  'Verification Email': 'Email verification',
  'Creez votre espace client Ahime.': 'Create your Ahime client workspace.',
  'Entrez le code recu sur': 'Enter the code sent to',
  'Nom': 'Name',
  'Email': 'Email',
  'Confirmation': 'Confirmation',
  'Inscription en cours...': 'Signing up...',
  'Creer mon espace client': 'Create my client workspace',
  'Deja inscrit ?': 'Already registered?',
  'Se connecter': 'Sign in',
  'Code de verification': 'Verification code',
  'Verification...': 'Verifying...',
  'Verifier et se connecter': 'Verify and sign in',
  'Renvoyer le code': 'Resend code',
  'Inscription impossible': 'Unable to register',
  'Verification impossible': 'Unable to verify',
  'Echec de connexion': 'Sign-in failed',
  'Echec de renvoi': 'Resend failed',
  'Menu principal': 'Main menu',
  'Administrateur': 'Administrator',
  'Deconnexion': 'Sign out',
  'Rechercher dans Ahime OS...': 'Search in Ahime OS...',
  'Notifications': 'Notifications',
  'Aucune notification.': 'No notifications.',
  'Espace Employe': 'Employee Space',
  'Espace Client': 'Client Space',
  'Vue generale': 'Overview',
  "Vue d'ensemble": 'Overview',
  'Mes Projets': 'My Projects',
  'Reunions': 'Meetings',
  'Parametres': 'Settings',
  'Facturation': 'Billing',
  'Fichiers & Validation': 'Files & Validation',
  'Mon Compte': 'My Account',
  'Recrutement': 'Recruitment',
};

const RAW_WORD_TRANSLATIONS: Record<string, string> = {
  'agence': 'agency',
  'digitale': 'digital',
  'ecosysteme': 'ecosystem',
  'projet': 'project',
  'projets': 'projects',
  'expertise': 'expertise',
  'expertises': 'expertise',
  'realisations': 'projects',
  'service': 'service',
  'services': 'services',
  'contact': 'contact',
  'inscription': 'registration',
  'connexion': 'login',
  'deconnexion': 'logout',
  'retour': 'back',
  'site': 'site',
  'article': 'article',
  'articles': 'articles',
  'introuvable': 'not found',
  'impossible': 'unable',
  'echec': 'failed',
  'envoyer': 'send',
  'envoi': 'sending',
  'verification': 'verification',
  'nom': 'name',
  'entreprise': 'company',
  'telephone': 'phone',
  'bureaux': 'offices',
  'message': 'message',
  'votre': 'your',
  'vos': 'your',
  'notre': 'our',
  'nos': 'our',
  'vous': 'you',
  'nous': 'we',
  'demarrer': 'start',
  'demande': 'request',
  'audit': 'audit',
  'envoyee': 'sent',
  'accueil': 'home',
  'mentions': 'legal',
  'legales': 'notice',
  'propriete': 'property',
  'intellectuelle': 'intellectual',
  'hebergement': 'hosting',
  'adresse': 'address',
  'support': 'support',
  'documents': 'documents',
  'operations': 'operations',
  'finances': 'finance',
  'parametres': 'settings',
  'dashboard': 'dashboard',
  'facturation': 'billing',
  'fichiers': 'files',
  'reunions': 'meetings',
  'espace': 'space',
  'client': 'client',
  'partenaire': 'partner',
  'employe': 'employee',
  'admin': 'admin',
  'compte': 'account',
  'securite': 'security',
  'aucun': 'no',
  'aucune': 'no',
  'disponible': 'available',
  'publie': 'published',
  'publies': 'published',
  'creer': 'create',
  'creez': 'create',
  'ouvrir': 'open',
  'fermer': 'close',
  'plus': 'more',
  'sur': 'on',
  'avec': 'with',
};

function normalizeTranslationKey(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’]/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function buildMap(source: Record<string, string>) {
  return Object.entries(source).reduce<Record<string, string>>((acc, [key, value]) => {
    acc[normalizeTranslationKey(key)] = value;
    return acc;
  }, {});
}

const PHRASE_TRANSLATIONS = buildMap(RAW_PHRASE_TRANSLATIONS);
const WORD_TRANSLATIONS = buildMap(RAW_WORD_TRANSLATIONS);

function preserveCase(source: string, target: string) {
  if (!source) return target;
  if (source.toUpperCase() === source) return target.toUpperCase();
  if (source[0] === source[0].toUpperCase()) return `${target.charAt(0).toUpperCase()}${target.slice(1)}`;
  return target;
}

function translateByWords(text: string) {
  return text.replace(/[A-Za-zÀ-ÖØ-öø-ÿ0-9'’]+/g, (word) => {
    const translated = WORD_TRANSLATIONS[normalizeTranslationKey(word)];
    if (!translated) return word;
    return preserveCase(word, translated);
  });
}

export function translateFrenchToEnglish(input: string): string {
  if (!input) return input;
  if (input.includes('@') || input.includes('http://') || input.includes('https://')) return input;

  const leading = input.match(/^\s*/)?.[0] || '';
  const trailing = input.match(/\s*$/)?.[0] || '';
  const core = input.slice(leading.length, input.length - trailing.length);

  if (!core) return input;
  if (!/[A-Za-zÀ-ÖØ-öø-ÿ]/.test(core)) return input;

  const phraseMatch = PHRASE_TRANSLATIONS[normalizeTranslationKey(core)];
  if (phraseMatch) return `${leading}${phraseMatch}${trailing}`;

  const byWords = translateByWords(core);
  return `${leading}${byWords}${trailing}`;
}
